<script setup lang="ts">
defineOptions({
	name: 'IconMakeFaceUpStar',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		:class="[props.class, props.classIcon]"
		viewBox="0 0 31 31"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M27.0731 15.1949C27.0731 21.4107 22.0342 26.4496 15.8184 26.4496C9.60259 26.4496 4.56369 21.4107 4.56369 15.1949C4.56369 8.97908 9.60259 3.94019 15.8184 3.94019"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M23.7466 3.17998C23.9115 2.8781 24.228 2.69031 24.572 2.69031C24.9159 2.69031 25.2325 2.8781 25.3973 3.17998L26.1264 4.51179C26.2129 4.67021 26.3431 4.80044 26.5015 4.88695L27.8333 5.61475C28.1359 5.77941 28.3242 6.09628 28.3242 6.44072C28.3242 6.78515 28.1359 7.10202 27.8333 7.26669L26.5015 7.99574C26.3427 8.08173 26.2124 8.21208 26.1264 8.3709L25.3973 9.70145C25.2325 10.0033 24.9159 10.1911 24.572 10.1911C24.228 10.1911 23.9115 10.0033 23.7466 9.70145L23.0176 8.36965C22.9316 8.21083 22.8012 8.08048 22.6424 7.99449L21.3106 7.26669C21.0081 7.10202 20.8198 6.78515 20.8198 6.44072C20.8198 6.09628 21.0081 5.77941 21.3106 5.61475L22.6424 4.88695C22.8008 4.80044 22.9311 4.67021 23.0176 4.51179L23.7466 3.17998Z"
			stroke="currentColor"
			stroke-width="1.91884"
		/>
		<path
			d="M12.0668 11.8561V13.1066"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.5699 11.8561V13.1066"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M19.8725 18.5189C17.6333 20.7564 14.0047 20.7564 11.7654 18.5189"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
